<template>
  <section>
    <div v-if="!isLoadingSubmitRequest">
      <b-alert
        show
        variant="danger"
      >
        <h4 class="alert-heading">
          Nota
        </h4>

        <div class="alert-body">
          <p>
            La lectura y búsqueda de registros en nuestros catálogos (como <span style="font-style: italic;">tipo de gobierno, entidad federativa, municipio, dependencia</span> u otros campos) pueden verse afectadas durante el proceso de registro. En caso de no encontrar coincidencias exactas en nuestros registros, el sistema asignará automáticamente el valor predeterminado <strong>"Desconocido"</strong>. Por lo cual será necesario realizar la edición de dichos registros en su módulo de aspirantes.
          </p>
        </div>
      </b-alert>
    </div>

    <div
      v-else
      class="text-center"
    >
      <b-spinner
        variant="primary"
        label="Loading..."
      />
      <p class="mt-1">
        Procesando solicitud, espere un momento...
      </p>
    </div>
  </section>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { heightFade } from '@core/directives/animations'
import {
  BAlert,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BSpinner,
    BAlert,
  },
  directives: {
    'height-fade': heightFade,
    Ripple,
  },
  props: {
    isLoadingSubmitRequest: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const showAlert = ref(true)

    watch(() => props.isLoadingSubmitRequest, value => {
      showAlert.value = !value
    })

    return {
      showAlert,
    }
  },
}

</script>
